import { Controller } from "@hotwired/stimulus"

// Toggles the `include_bonus` query param on ADIF export links when the
// checkbox changes, so admins can choose whether a club's export includes the
// bonus-station contacts its activators earned. The server treats the param as
// the source of truth.
export default class extends Controller {
  static targets = ["link"]

  toggle(event) {
    const include = event.target.checked

    this.linkTargets.forEach((link) => {
      const url = new URL(link.href, window.location.origin)

      if (include) {
        url.searchParams.set("include_bonus", "1")
      } else {
        url.searchParams.delete("include_bonus")
      }

      link.href = url.toString()
    })
  }
}
